import { render, staticRenderFns } from "./DiscretionaryTrust.vue?vue&type=template&id=1f69c09a"
import script from "./DiscretionaryTrust.vue?vue&type=script&lang=js"
export * from "./DiscretionaryTrust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports